import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import { CreateInventoryItemInput, InventoryItemEntry } from '../../types/inventory';

interface CreateInventoryItemResponse {
    item: InventoryItemEntry;
}

const createInventoryItem = async (
    input: CreateInventoryItemInput,
    sessionId: string | null,
): Promise<CreateInventoryItemResponse> => {
    const { data } = await axios.post(`${API_URL}/inventory/create`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useCreateInventoryItem = (
    options?: UseMutationOptions<CreateInventoryItemResponse, unknown, CreateInventoryItemInput>,
) => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (input: CreateInventoryItemInput) =>
            createInventoryItem(input, sessionContext?.sessionId ?? null),
        ...options,
    });
};
